import { WebAuth } from 'auth0-js';

function getWebAuth(): WebAuth {
  const configElement = document.getElementById('login-config');
  const configRaw = JSON.parse(
    configElement?.textContent || '{ hostedConfig: "@@config@@" }',
  );

  const hostedConfigRaw = configRaw.hostedConfig;

  const isHostedConfig = hostedConfigRaw !== '@@config@@';
  let config = {
    domain: '',
    clientID: '',
    redirectUri: '',
    responseType: 'code',
    overrides: {
      __tenant: '',
      __token_issuer: '',
    },
    title: '',
  };
  let hostedConfig;

  if (isHostedConfig) {
    hostedConfig = JSON.parse(
      decodeURIComponent(escape(window.atob(hostedConfigRaw))),
    );
    config.domain = hostedConfig.auth0Domain;
    config.clientID = hostedConfig.clientID;
    config.redirectUri = hostedConfig.callbackURL;
    config.responseType = hostedConfig.internalOptions?.response_type || 'code';
    config.overrides = {
      __tenant: hostedConfig.auth0Tenant,
      __token_issuer: hostedConfig.auth0Domain,
    };
    config.title = hostedConfig.dict?.signin?.title || 'CKC & partners';
    config = Object.assign(config, hostedConfig.internalOptions);
  } else {
    config.domain = 'ckc-zoetermeer-dev.eu.auth0.com';
    config.clientID = 'abc123';
    config.responseType = 'code';
    config.title = 'CKC & partners';
  }

  const auth0 = new WebAuth(config);

  return auth0;
}

export default getWebAuth;
